<template>
  <div class="manual-text">
    <div>
      <h1 class="text-center mt-2 mb-10">Clone Project</h1>
      <p>
        Similar to adding a new project, the user can clone an existing project in their account from the projects page.
        After deciding which project is the one to be cloned, the user should <b>click the green <i class="fas fa-copy"/>
        copy button</b> from the project's options.
      </p>

      <div class="image-container">
        <img src="@/images/manual/projects-page-clone-button.png" alt="clone project button" />
        <div class="img-caption">
          Figure 1. Clone Project button's location
        </div>
      </div>

      <p>
        Once the button is clicked, a modal will appear on the screen, which will prompt the user to select a <b>name</b>
        for the cloned project. By default, the name suggested is "[Project Name] - Copy", but the user is free to
        choose any name. As in the case of the New Project creation, the selected name must <b>not be the same</b> as
        any of the already-existing project names. Again, in such cases the user will be informed with a small message
        below the project name field.
      </p>

      <div class="image-container">
        <v-row>
          <v-col>
            <img src="@/images/manual/clone-project-prompt.png" alt="clone project prompt" />
          </v-col>
          <v-col>
            <img src="@/images/manual/clone-project-invalid-prompt.png" alt="clone project invalid prompt" />
          </v-col>
        </v-row>
        <div class="img-caption">
          Figure 2. The cloning prompt with a valid name (left) and an invalid name (right).
        </div>
      </div>

      <p>
        After a valid project name has been provided, the "Clone" button must be pressed afterwards, which will refresh
        the page; showing the new project. The cloned project will have <b>every single KPI and PSI</b> with all their
        options being <b>an exact copy of the original project.</b>
      </p>

      <div class="image-container">
        <img src="@/images/manual/projects-page-post-cloning.png" alt="cloned project" />
        <div class="img-caption">
          Figure 3. Clone Project button's location
        </div>
      </div>

    </div>
  </div>
</template>

<script setup>

</script>

<style scoped>

</style>
